<template>
    <section :id="`element-${settings.id}`" :class="classes" :style="{ backgroundColor: settings?.color }" data-is-hero>
        <div class="container">
            <div class="grid12">
                <div class="l-col">
                    <UiHeadline
                        :settings="{
                            label: settings?.label,
                            headline: settings?.headline
                        }"
                    >
                        <template #additional>
                            <div v-if="settings?.linksUrls.length" class="buttons">
                                <UiLink v-for="(link, index) in settings?.linksUrls" :key="index" :link="link" :style="'transparent w-border'" />
                            </div>
                        </template>
                    </UiHeadline>
                </div>
                <div v-if="settings?.body" class="m-col">
                    <div class="content typography" v-html="props.settings?.body" />
                </div>
                <div class="r-col">
                    <UiMediaWithVideo :media="settings?.media" :video="settings?.video" />
                </div>
            </div>
        </div>
    </section>
</template>

<script setup lang="ts">
const props = defineProps({
    settings: {
        type: Object,
        default: () => ({})
    }
});

const classes = computed(() => (props.settings?.fullScreen ? 'elle-intro-hero f-screen' : 'elle-intro-hero'));
</script>
